import { Button } from "@/components/ui/button";
import { getFriendlyErrorMessage } from "@/lib/api-client";
import { SEQUENCE_OBJECTIVE_OPTIONS, type SequenceObjective } from "@/types/sequence.types";

interface Props {
  queueSize: number;
  creating: boolean;
  error: unknown;
  onStart: (objective: SequenceObjective) => void;
}

// Passo 1 do drawer: o que otimizar. Três opções fixas — o lote COMPARA estratégias conhecidas,
// não faz busca livre; deixar isso explícito evita a expectativa de "otimizador".
export function SequenceObjectiveStep({ queueSize, creating, error, onStart }: Props) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">
        {queueSize} ordens agendadas nesta linha. Vamos simular a fila atual e duas alternativas
        (por prazo e agrupada por produto) para comparar o resultado.
      </p>

      <fieldset className="space-y-2">
        <legend className="text-sm font-medium">O que você quer melhorar?</legend>
        {SEQUENCE_OBJECTIVE_OPTIONS.map((option) => (
          <button
            key={option.id}
            type="button"
            disabled={creating}
            onClick={() => onStart(option.id)}
            className="flex w-full flex-col items-start rounded-md border p-3 text-left transition-colors hover:border-primary hover:bg-muted/40 disabled:opacity-60"
          >
            <span className="text-sm font-medium">{option.label}</span>
            <span className="text-xs text-muted-foreground">{option.hint}</span>
          </button>
        ))}
      </fieldset>

      {error ? (
        <div className="space-y-2 rounded-md border border-destructive/40 bg-destructive/5 p-3">
          <p className="text-sm text-destructive">{getFriendlyErrorMessage(error)}</p>
          <Button size="sm" variant="outline" onClick={() => onStart("TOTAL_LATENESS")}>
            Tentar de novo
          </Button>
        </div>
      ) : null}
    </div>
  );
}
